import React from 'react';
import PropTypes from 'prop-types';
import { Typography as MuiTypography } from '@mui/material';

// Component scope - Constants and static data
const TYPOGRAPHY_VARIANTS = [
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'subtitle1', 'subtitle2',
  'body1', 'body2',
  'caption', 'overline',
  'button'
];
const ALIGN_OPTIONS = ['inherit', 'left', 'center', 'right', 'justify'];
const COLOR_OPTIONS = [
  'initial', 'inherit', 'primary', 'secondary', 'textPrimary', 
  'textSecondary', 'error', 'warning', 'info', 'success'
];

/**
 * App Typography Component - Wrapper for MUI Typography
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} AppTypographyComponent
 */
const AppTypographyComponent = ({ 
  variant = 'body1',
  component,
  align = 'inherit',
  color = 'initial',
  gutterBottom = false,
  noWrap = false,
  paragraph = false,
  children,
  ...props 
}) => {
  // Return/rendering
  return (
    <MuiTypography
      variant={variant}
      component={component}
      align={align}
      color={color}
      gutterBottom={gutterBottom}
      noWrap={noWrap}
      paragraph={paragraph}
      {...props}
    >
      {children}
    </MuiTypography>
  );
};

AppTypographyComponent.propTypes = {
  variant: PropTypes.oneOf(TYPOGRAPHY_VARIANTS),
  component: PropTypes.elementType,
  align: PropTypes.oneOf(ALIGN_OPTIONS),
  color: PropTypes.oneOf(COLOR_OPTIONS),
  gutterBottom: PropTypes.bool,
  noWrap: PropTypes.bool,
  paragraph: PropTypes.bool,
  children: PropTypes.node,
  sx: PropTypes.object,
  onClick: PropTypes.func,
};

export default AppTypographyComponent;


